// Copyright (c) Hamilton Manufacturing Corp.

import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const LinkTo = styled.a`
    text-decoration-thickness: 0.05em;
    &:link {
        color: ${({ theme }) => theme.link};
    }
    &:visited {
        color: ${({ theme }) => theme.link};
    }
    &:hover {
        color: ${({ theme }) => theme.highlight}
    }
    &:active {
        color: ${({ theme }) => theme.active}
    }
`

const LinkA = LinkTo.withComponent(Link)

const HamLink = ({ icon, children, ...props }) =>
    props.to ?
        <LinkA {...props}>{children}</LinkA> :
        <LinkTo {...props}>{children}</LinkTo>

export default HamLink;